import { Card, CardHeader, CardText } from "material-ui/Card";
import React, { Component } from "react";
import "./education.css";

const style1 = {
  background: "linear-gradient(45deg, #00F260 , #0575E6 )",
  borderRadius: 3,
  border: 0,
  color: "white",
  // height: 48,
  padding: "0 30px",
  boxShadow: "0 3px 5px 2px rgba(255, 105, 135, .3)",
  maxHeight: 500,
  overflow: "auto"
};

const style2 = {
  background: "linear-gradient(45deg, #fc4a1a , #f7b733 )",
  borderRadius: 3,
  border: 0,
  color: "white",
  // height: 48,
  padding: "0 30px",
  boxShadow: "0 3px 5px 2px rgba(255, 105, 135, .3)",
  maxHeight: 500,
  overflow: "auto"
};

class TimelineComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded1: false,
      expanded2: false,
      expanded3: false
    };
  }

  async componentDidMount() {}

  componentWillUnmount() {}

  handleExpandChange = expanded1 => {
    this.setState({ expanded1: expanded1 });
  };

  handleExpandChange2 = expanded2 => {
    this.setState({ expanded2: expanded2 });
  };

  handleExpandChange3 = expanded3 => {
    this.setState({ expanded3: expanded3 });
  };

  handleExpand = () => {
    this.setState({ expanded: true });
  };

  handleExpand2 = () => {
    this.setState({ expanded2: true });
  };

  handleExpand3 = () => {
    this.setState({ expanded3: true });
  };

  handleReduce = () => {
    this.setState({ expanded1: false });
  };

  handleReduce2 = () => {
    this.setState({ expanded2: false });
  };

  handleReduce3 = () => {
    this.setState({ expanded3: false });
  };
  render() {
    return (
      <div className="timeline">
        <p className="headline">Education</p>
        <div className="timeline-entry">
          <Card style={style1}>
            <CardHeader
              title="Master of Data Science"
              subtitle="Monash University, Melbourne"
              actAsExpander={true}
              showExpandableButton={true}
            />
            <CardText expandable={true}>
              2017 – current.
              <br />
              <br />
            </CardText>
          </Card>
        </div>
        <div className="timeline-entry">
          <Card
            style={style2}
            expanded={this.state.expanded1}
            onExpandChange={this.handleExpandChange}
          >
            <CardHeader
              title="Bachelor in Economics and Mathematics"
              subtitle="Institute of Business Administration (IBA), Karachi"
              actAsExpander={true}
              showExpandableButton={true}
            />
            <CardText expandable={true}>
              2013 - 2016.
              <br />
              <br />
              FYP: “MODELLING OIL PRICE RISK (An econometric approach via
              Symmetric and Asymmetric models to support hedge investments.”
              <br />
              <br />
            </CardText>
          </Card>
        </div>
        <div className="timeline-entry">
          <Card
            style={style1}
            expanded={this.state.expanded2}
            onExpandChange={this.handleExpandChange2}
          >
            <CardHeader
              title="Cambridge International Examinations – O & A Levels"
              subtitle="Beaconhouse School System"
              actAsExpander={true}
              showExpandableButton={true}
            />
            <CardText expandable={true}>2008 – 2012.</CardText>
          </Card>
        </div>
      </div>
    );
  }
}

export default TimelineComponent;
